import React from "react";
import Select from "react-select";
import "./Select_Dropdown_holder.css";

const options = [
  {
    value: "lykam_matte",
    label: "Lykam Matte Coated Paper 300 Gsm Thick Card",
  },
  { value: "glossy_paper", label: "Glossy Coated Paper 250 Gsm" },
  { value: "premium_card", label: "Premium Matte Card 350 Gsm" },
];

function Select_Dropdown_holder({
  control,
  handleSubmit,
  handleChange,
  option,
  placeholder,
}) {
  return (
    <section className="Select_Dropdown_holder">
      <Select
        placeholder={placeholder || "Select"}
        options={option}
        defaultValue={option?.[0]} 
        className="Select_Dropdown_holder__select"
        classNamePrefix="custom-select"
        isSearchable={false}
        onChange={handleChange}
      />
    </section>
  );
}

export default Select_Dropdown_holder;
